export default __webpack_public_path__ + "static/char-s-35-zh-Hant-8f7405405248c6bd0f59e9d37a98a8ab.png";